<template>
  <!-- 合同订单统计 -->
  <div>
    <div class="home-pannel">
      <div class="home-pannel-title">
        <span>合同订单统计</span>
        <div>
          <time-query @select="timeSelect"/>
        </div>
      </div>
      <div class="home-pannel-content">
        <a-row>
          <a-col :span="17">
            <myLineEcharts ref="contractEchartsRef" echarts-id-val="contractEcharts" line-title-name="合同金额统计" :echarts-height="echartsHeight"/>
          </a-col>
          <a-col :span="7" class="right-content">
            <a-row v-for="(item,index) in jbkbList" :key="index" type="flex" justify="space-around">
              <a-col v-for="(el, ind) in item" :key="ind" :span="10" style="margin-top: 40px;text-align:center;">
                <span v-if="el.slot" class="jineValue">
                  <span :style="el.color ? 'color:#f5222d;' : ''">{{setJine(jbkbDataObj[el.value])}}</span>
                </span>
                <span v-else class="jineValue">{{jbkbDataObj[el.value]}}</span>
              <br>
                <span :style="el.color ? 'color:#f5222d;' : ''">
                  {{el.name}}
                  <span v-if="el.slot">({{setUnit(jbkbDataObj[el.value])}})</span>
                </span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import timeQuery from './queryView.vue'
import myLineEcharts from './myLine.vue'
import { setJine, setUnit } from '@/utils/index.js'
export default {
  components: {myLineEcharts, timeQuery},
  props: {
    echartsHeight: {
      type: String,
      default: '350px'
    }
  },
  data () {
    return {
      jbkbDataObj: {},
      jbkbList: [
        [
          {
            name: '合同单数(个)',
            value: 'contractNum'
          },
          {
            name: '合同总额',
            value: 'contractTotalMoney',
            slot: 'jine'
          }
        ],
        [
          {
            name: '已回款单数(个)',
            value: 'backContractNum'
          },
          {
            name: '已回款额',
            value: 'backMoney',
            slot: 'jine'
          }
        ],
        [
          {
            name: '未回款单数(个)',
            value: 'unBackContractNum'
          },
          {
            name: '未回款额',
            value: 'unBackMoney',
            slot: 'jine',
            color: true
          }
        ]
      ]
    }
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    setJine,
    setUnit,
    timeSelect (timeVal) {
      this.getData(timeVal)
    },
    getData (timeVal) {
      this.$get('/contract/mobile/board', {timeCondition: timeVal}).then(res => {
        if (res.data.status === 1) {
          this.jbkbDataObj = res.data.data
          this.$nextTick(() => {
            this.$refs.contractEchartsRef.setData(this.jbkbDataObj.histogramVoList)
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.right-content{
  margin-top: 20px;
}
  .jineValue{
    color:#4b9de1;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/contractInfo.vue